
// Password validation rules
export const PASSWORD_MIN_LENGTH = 8;

export interface PasswordValidationResult {
  isValid: boolean;
  errors: string[];
}

export function validatePassword(password: string): PasswordValidationResult {
  const errors: string[] = [];
  
  if (password.length < PASSWORD_MIN_LENGTH) {
    errors.push(`Parool peab olema vähemalt ${PASSWORD_MIN_LENGTH} tähemärki pikk`);
  }
  
  if (!/[A-Z]/.test(password)) {
    errors.push("Parool peab sisaldama vähemalt üht suurtähte");
  }
  
  if (!/[a-z]/.test(password)) {
    errors.push("Parool peab sisaldama vähemalt üht väiketähte");
  }
  
  if (!/[0-9]/.test(password)) {
    errors.push("Parool peab sisaldama vähemalt üht numbrit");
  }
  
  if (!/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password)) {
    errors.push("Parool peab sisaldama vähemalt üht erimärki (!@#$%^&*()_+-=[]{};':\"\\|,.<>/?)")
  }
  
  return {
    isValid: errors.length === 0,
    errors
  };
}
